import { MetaPixelAnalyticsProviderAdapter } from '../providers/meta-pixel'

export const makeMetaPixelProvider = {
  metaPixel: (pixelId) => {
    if (typeof window === 'undefined') {
      return null
    }

    if (!pixelId) {
      if (process.env.NODE_ENV !== 'production') {
        // eslint-disable-next-line no-console
        console.log('Meta Pixel ID not provided. Analytics will be disabled.')
      }
      return null
    }

    return new MetaPixelAnalyticsProviderAdapter(pixelId)
  },
}
